<template>
  <div class="problem-flight-v2__content">
    <h2 class="problem-flight-v2__content__title">{{ fields?.search_title }}</h2>
    <div class="problem-flight-v2__content__form">
      <SearchSelect
        v-if="fields?.show_airline_search_fields"
        :placeholder="fields?.search_airline_text"
        apiType="airlines"
        @update:value="handleAirlineSelect"
        @clear-search="fetchProblemFlights"
      />
      <SearchSelect
        v-if="fields?.show_airport_search_field"
        :placeholder="fields?.search_airport_text"
        apiType="airports"
        @update:value="handleAirportSelect"
        @clear-search="fetchProblemFlights"
      />
    </div>
    <div v-if="loading" class="loading-indicator">
      <div class="spinner"></div>
    </div>
    <FlightDetails v-else :flights="flightList" :fields="fields"/>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, ref, watch } from 'vue';
import SearchSelect from "./SearchSelect/SearchSelect.vue";
import FlightDetails from "./FlightDetails/FlightDetails.vue";
import Item, { InitialData, SelectedValue } from "../types/types";
import { getProblemFlightsFromAPI } from '../api/APIService';

const selectedAirport = ref<SelectedValue | null>(null);
const selectedAirline = ref<SelectedValue | null>(null);
const apiCallCompleted = ref(false);
const flightList = ref<Item[]>([]);
const loading = ref(false);

const props = defineProps<{
    fields: InitialData | null;
}>();

const resetSelection = () => {
  selectedAirport.value = { code: "", name: "" };
  selectedAirline.value = { code: "", name: "" };
};

onUnmounted(resetSelection);

const handleAirportSelect = (value: SelectedValue) => {
  selectedAirport.value = value;
  if (selectedAirport.value?.name?.length > 0) {
    fetchProblemFlights();
  };
};

const handleAirlineSelect = (value: SelectedValue) => {
  selectedAirline.value = value;
  if (selectedAirline.value?.name?.length > 0) {
    fetchProblemFlights();
  };
};

const fetchProblemFlights = async () => {
  loading.value = true;
  const Category = props.fields?.list_type || "";
  const AirlineCode = Category === "airline" ? props.fields?.iata : "";
  const AirportCode = Category === "airport" ? props.fields?.iata : "";
  try {
    const data = {
      url: 'getproblemflights',
      payload: {
        date: '',
        airlineCode: selectedAirline.value?.code || AirlineCode,
        airportCode: selectedAirport.value?.code || AirportCode,
        limit: 10,
      },
    };
    const response = await getProblemFlightsFromAPI(data);
    if (response.status === 200) {
      apiCallCompleted.value = true;
      flightList.value = response.data as Item[];
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    loading.value = false; 
  }
};

</script>